import { CardMeta } from './models';

export const mapToCardMeta = (item: any): CardMeta => {
  const rawDate: string | undefined =
    item?.eventTimestamp?.event_start_date ??
    item?.pageAdditionalData?.initial_publish_date ??
    item?.updatedAt ??
    undefined;

  const resourceConsumptionType = item?.pageAdditionalData?.content_type;

  const durationRaw = item?.pageAdditionalData?.duration;

  let durationMinutes: number | null = null;

  if (typeof durationRaw === 'number') {
    durationMinutes = durationRaw;
  } else if (durationRaw !== undefined && durationRaw !== null) {
    const parsed = Number(durationRaw);
    durationMinutes = Number.isNaN(parsed) ? null : parsed;
  }

  const resourceLink = item?.pageAdditionalData?.resource_link || undefined;

  const date = rawDate ?? null;
  const isPastEvent =
    typeof rawDate === 'string'
      ? new Date(rawDate).getTime() < Date.now()
      : false;

  return {
    date,
    rawDate,
    durationMinutes,
    isPastEvent,
    resourceLink,
    resourceConsumptionType,
  };
};
